import Avatar from "react-avatar";
import gallary1 from "../../assats/gallary1.webp";

const Profile = () => {
    return (
        <>


            <div class=" flex justify-center mt-48 ">


                <div class="max-w-sm  rounded-lg shadow bg-gray-800">
                    <a href="#">
                        <img class="rounded-t-lg" src={gallary1} alt="" />
                    </a>
                    <div class="p-5">
                        <a href="#">
                            <h5 class="mb-2 text-2xl font-bold  text-white text-center">Test user</h5>
                        </a>
                        <p class="mb-3 text-center text-gray-400">testuser@gmail.com</p>
                        <div className="flex justify-between">
                            <a href="#" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                Back
                            </a>
                            <a href="#" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                Log out
                                <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
export default Profile;


// import React, { useState } from 'react'

// function Profile() {
//     const productList = ["blue pant"
//         , "black pant"
//         , "blue shirt"
//         , "black shoes"
//         , "brown shoes"
//         , "white pant"
//         , "white shoes"
//         , "red shirt"
//         , "gray pant"
//         , "white shirt"
//         , "golden shoes"
//         , "dark pant"
//         , "pink shirt"
//         , "yellow pant"];
//     const [products, setProducts] = useState(productList);
//     const [searchVal, setSearchVal] = useState("");
//     function handleSearchClick() {
//         if (searchVal === "") { setProducts(productList); return; }
//         const filterBySearch = productList.filter((item) => {
//             if (item.toLowerCase()
//                 .includes(searchVal.toLowerCase())) { return item; }
//         })
//         setProducts(filterBySearch);
//     }
//     const mystyle = {
//         marginLeft: "600px",
//         marginTop: "20px",
//         fontWeight: "700"
//     };

//     return (
//         <div>
//             <div style={mystyle}>
//                 <input onChange={e => setSearchVal(e.target.value)}>
//                 </input>
//                 <p onClick={handleSearchClick} >search</p>
//             </div>
//             <div>

//                 {products.map((product) => {
//                     return (
//                         <div style={mystyle}>{product}</div>
//                     )
//                 })
//                 }

//             </div>
//         </div>
//     );
// }

// export default Profile;